import { MediaPackBenchmarkType } from '~/types';

import {
  MediaPackDetailHighlightCheckboxCard,
  THighlightCheckboxCard,
} from '../../MediaPackDetailHighlightCheckboxCard';

interface Props
  extends Omit<THighlightCheckboxCard, 'isChecked' | 'isDisabled'> {
  isMultiselect: boolean;
  metricKey: MediaPackBenchmarkType;
  metricKeys: MediaPackBenchmarkType[];
  otherMetricKey: MediaPackBenchmarkType[];
}

export const CheckboxCard: React.FC<Props> = ({
  isMultiselect,
  metricKey,
  metricKeys,
  otherMetricKey,
  ...props
}) => {
  const isChecked = metricKeys.includes(metricKey);
  const isDisabled = otherMetricKey.includes(metricKey);
  const position: number | undefined = isMultiselect
    ? metricKeys.findIndex((key) => key === metricKey) + 1
    : undefined;

  return (
    <MediaPackDetailHighlightCheckboxCard
      isChecked={isChecked}
      isDisabled={isDisabled}
      position={position}
      metricKey={metricKey}
      {...props}
    />
  );
};
